import React from 'react'
import './ProgressSection.scss'
import progressChartIcon from '../../../../assets/progress-chart-icon.svg'
import { useTranslation } from 'react-i18next'

const ProgressSection = ({ leaderboardData }) => {
  const progressPercentage = leaderboardData.progress || 0 // Default to 0 if progress is not available

  const level = leaderboardData.level || ''

  const { t } = useTranslation()

  const nextLevelPercentage = (progressPercentage / 100) * 100

  const nextLevelText = `${progressPercentage}% ${level &&
    `${t('general:of')} ${level}`}`
  const completedText = `${progressPercentage}% ${t('general:completed')}`

  return (
    <div className="progress-section">
      <div className="progress-content">
        <div className="progress-text">{nextLevelText}</div>
        <div className="progress-bar-container">
          <div className="progress-bar-section">
            <div
              className="progress-fill"
              style={{ width: `${progressPercentage}%` }}
            ></div>
          </div>
          <div className="progress-percentage">{completedText}</div>
        </div>
      </div>
      <div className="progress-icon">
        <img
          src={progressChartIcon}
          alt="Progress chart icon"
          width="64"
          height="65"
        />
      </div>
    </div>
  )
}

export default ProgressSection
